import crawlApi from './crawlApi';

type JobPage = string | number | null | undefined;

type DeleteHistoryArgs = {
  job_page: JobPage;
  domain_slug: string | null | undefined;
};

const historyApi = crawlApi.injectEndpoints({
  endpoints: build => ({
    countCrawlHistory: build.query<unknown, JobPage>({
      query: (domain_slug: JobPage) => ({
        url: '/khazesh/v3/history/count',
        method: 'POST',
        body: { domain_slug: domain_slug }
      }),
      keepUnusedDataFor: 3,
      providesTags: ['CrawlHistory']
    }),

    deleteHistory: build.mutation<unknown, DeleteHistoryArgs>({
      query: ({ job_page, domain_slug }) => ({
        url: '/khazesh/v3/history/delete',
        method: 'POST',
        params: { job_page, domain_slug }
      })
    })
  })
});

export const { useCountCrawlHistoryQuery, useDeleteHistoryMutation } =
  historyApi;

export default historyApi;
